export default __webpack_public_path__ + "static/media/Selo Governanca.6fdb0116.png";